import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Link,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const CopyrightPage = () => {
  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="stretch">
        <Box>
          <Heading>Copyright Policy</Heading>
        </Box>
        <Box>
          <Text>
            Megalith Maps respects the intellectual property rights of others
            and expects its users to do the same. It is our policy, in
            appropriate circumstances and at our discretion, to disable and/or
            terminate the accounts of users who repeatedly infringe or are
            repeatedly charged with infringing the copyrights or other
            intellectual property rights of others.
          </Text>
        </Box>
        <Box>
          <Heading size="md">Procedure for Reporting Copyright Infringements</Heading>
          <Text mt={2}>
            If you are a copyright owner, or are authorized to act on behalf of
            one, or authorized to act under any exclusive right under
            copyright, please report alleged copyright infringements taking
            place on or through the site by completing the following DMCA Notice
            of Alleged Infringement and delivering it to our designated
            Copyright Agent.
          </Text>
          <Link as={RouterLink} to="/dmca" color="blue.500">
            DMCA Takedown Request Form
          </Link>
        </Box>
        <Box>
          <Heading size="md">Requesting Credit</Heading>
          <Text mt={2}>
            If you are the copyright holder of an image and would like to be
            credited, please use our credit request form.
          </Text>
          <Link as={RouterLink} to="/request-credit" color="blue.500">
            Request Credit Form
          </Link>
        </Box>
      </VStack>
    </Container>
  );
};

export default CopyrightPage;
